import { CollectionId } from "@genai/collection";
import { AssistantId } from "@genai/assistant";
import { FileId } from "../../file/model";

export type ChatId = string & {
  readonly __brand_chat__: unique symbol;
};

export type MessageId = string & {
  readonly __brand_message__: unique symbol;
};

export const role = {
  user: "user",
  assistant: "assistant",
} as const;

export type Role = (typeof role)[keyof typeof role];

export const status = {
  pending: "pending",
  success: "success",
  error: "error",
  streaming: "streaming",
} as const;

export interface Filter  {
  hidden: string
}

export type Status = (typeof status)[keyof typeof status];

export const equipmentType = {
  heating: "HEATING",
  cooling: "COOLING",
} as const;

export type EquipmentType = (typeof equipmentType)[keyof typeof equipmentType];

export interface ChatMessage {
  uuid: MessageId;
  role: Role;
  status: Status;
  rating?: string;
  filters?: Filter
  content: string;
  sources?: Source[];
  error?: string;
}

export interface ApiChatMessage {
  uuid: MessageId;
  role: Role;
  content: string;
  filters: Filter;
}

export interface Chat {
  uuid: ChatId;
  name: string;
  assistant: AssistantId;
  collection: CollectionId;
  fileIds?: FileId[];
  brand: string;
  model: string
}

export interface ApiChat {
  uuid: ChatId;
  name: string;
  collection: CollectionId;
  assistant: AssistantId;
  brand: string;
  model: string;
}

export interface PDFSource {
  fileId: FileId;
  collectionId: CollectionId;
  mimetype: "application/pdf";
  pages?: number[];
}

export interface PPTSource {
  fileId: FileId;
  collectionId: CollectionId;
  mimetype: "application/vnd.openxmlformats-officedocument.presentationml.presentation";
  pages?: number[];
}

export interface WordSource {
  fileId: FileId;
  collectionId: CollectionId;
  mimetype:
    | "application/msword"
    | "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  htmlContent?: string;
}

export type Source = PDFSource | WordSource | PPTSource;

export interface ApiSource {
  file_uuid: FileId;
  collection_uuid: CollectionId;
  mimetype: string;
  mimetype_specific_metadata: unknown;
}
